<template>
  <span
    class="tpl:mx-1 tpl:h-6 tpl:w-px tpl:bg-[var(--tpl-border)]"
    aria-hidden="true"
  ></span>
</template>
